import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import '@nimling/components-nimtech/dist/style.css'
import './app.css'
import { theme, applyTheme } from '@lib/store/theme'

applyTheme(theme.value)

createApp(App).use(router).mount('#app')
